import type { ReactNode } from "react";

export function ThreeDotsIcon(): ReactNode {
	return (
		<svg
			fill="none"
			height="24"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="1.25"
			viewBox="0 0 24 24"
			width="24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M0 0h24v24H0z" fill="none" stroke="none" />
			<path d="M4 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
			<path d="M11 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
			<path d="M18 12a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
		</svg>
	);
}
